import axios from 'axios'

const baseurl = `${import.meta.env.VITE_APP_PROTOCOL}://${import.meta.env.VITE_API_HOST}:${import.meta.env.VITE_API_PORT}/${import.meta.env.VITE_API_SUBPATH}`
const url = 'apprs'

export const inuseAppAPI = async (app_id: number) => {
  const response = await axios.get(`${baseurl}${url}`, {
    params: {
      cmd: 'inuse',
      app_id: app_id,
    }
  })
  console.log("inuseAppAPI 응답:", response.data)
  return response.data.data
}